import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';

    export default GenericModel.extend({
        urlRoot: '/CampaignCloud/CreditsController/ExpansionTypes',
        url: function () {
            return this.urlRoot;
        },
        idAttribute: 'expansionTypeId',
        defaults: {
            expansionTypeId: 0,
            accountType: 'basic',
            months: 0,
            euros: 0
        }
    });
